import { scrollIntoViewSettled } from '~/utils/scrollIntoViewSettled';

export const TRANSPORT_PASSES_SECTION_ID = 'transport-passes';
export const TRANSPORT_INTERRAIL_SECTION_ID = 'transport-interrail';
export const TRANSPORT_SEATING_SECTION_ID = 'transport-seating';
export const TRANSPORT_ITINERARY_SECTION_ID = 'transport-itinerary';
export const TRANSPORT_RAILCARDS_SECTION_ID = 'transport-railcards';
export const TRANSPORT_MAP_HEADING_ID = 'transport-map-heading';

export const scrollToTransportSection = (id: string) => {
  const el = document.getElementById(id);
  if (el) void scrollIntoViewSettled(el);
};
